import { useMemo, useState } from "react";
import { Search, UserPlus } from "lucide-react";

const fmtD = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "—");

/** Ricerca e aggiunta di qualsiasi dipendente (attivo o cessato) in forza nel periodo della dichiarazione. */
export function AutodichiarazioneEmployeePicker({ employees, onAdd, disabled }) {
    const [q, setQ] = useState("");
    const [open, setOpen] = useState(false);
    const list = useMemo(() => {
        const needle = q.trim().toLowerCase();
        return (employees || [])
            .filter((e) => !needle || `${e.cognome} ${e.nome} ${e.codice_fiscale || ""} ${e.matricola || ""}`.toLowerCase().includes(needle))
            .slice(0, 40);
    }, [employees, q]);
    const pick = (id) => { onAdd(id); setQ(""); setOpen(false); };
    return (
        <div className="relative w-full sm:w-80" data-testid="ad-picker">
            <div className="flex h-9 items-center gap-2 rounded-md border border-slate-200 bg-white px-2 focus-within:border-[#376DB3]">
                <UserPlus className="h-3.5 w-3.5 shrink-0 text-[#376DB3]" />
                <input value={q} disabled={disabled} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
                    onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
                    placeholder="Aggiungi dipendente (attivo o cessato)…"
                    className="h-full w-full bg-transparent text-sm outline-none placeholder:text-slate-400" data-testid="ad-picker-search" />
                <Search className="h-3.5 w-3.5 shrink-0 text-slate-400" />
            </div>
            {open && !disabled && (
                <div className="absolute left-0 right-0 top-full z-30 mt-1 max-h-72 overflow-y-auto rounded-md border border-slate-200 bg-white p-1 shadow-lg" data-testid="ad-picker-list">
                    {list.length === 0 && <div className="px-2 py-3 text-xs text-slate-400" data-testid="ad-picker-empty">Nessun altro dipendente in forza nel periodo</div>}
                    {list.map((e) => (
                        <button type="button" key={e.id} onMouseDown={(ev) => ev.preventDefault()} onClick={() => pick(e.id)}
                            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-xs hover:bg-slate-50" data-testid={`ad-picker-item-${e.id}`}>
                            <span className="flex-1 truncate font-semibold text-slate-700">{e.cognome} {e.nome}
                                <span className="font-normal text-slate-400"> · {e.codice_fiscale || "CF mancante"}</span>
                            </span>
                            <span className="shrink-0 font-mono-numbers text-[11px] text-slate-500">dal {fmtD(e.data_assunzione)}</span>
                            {e.data_cessazione
                                ? <span className="shrink-0 rounded bg-slate-100 px-1 py-px text-[10px] font-semibold uppercase text-slate-600">cessato {fmtD(e.data_cessazione)}</span>
                                : <span className="shrink-0 rounded bg-emerald-50 px-1 py-px text-[10px] font-semibold uppercase text-emerald-700">attivo</span>}
                        </button>
                    ))}
                    {(employees || []).length > list.length && <div className="px-2 py-1 text-[10px] text-slate-400">Affina la ricerca per vedere altri risultati…</div>}
                </div>
            )}
        </div>
    );
}
